<template>
  <div class="upCard">
    <div class="upCard__inner">
      <slot />
    </div>
    <slot name="stretch-link" />
  </div>
</template>

<script>
export default {
  name: 'upCard',
};
</script>

<style lang="scss">
  .upCard {
    position: relative;
    height: 100%;
    padding: 16px 12px 12px;
    background: #FFFEFB;
    border-radius: 24px;
    overflow: hidden;

    box-shadow: 0 0 8px 1px rgba(45, 48, 56, 0.15);

    &-sm {
      border-radius: 10px;
    }

    &.profile-card {
      width: 100%;
    }

    .upCard__inner {
      display: flex;
      height: 100%;
      flex-direction: column;
      gap: 15px;
    }
    .stretch-link {
      background: transparent;
      border: none;
      height: 0;
      width: 0;
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
    }
  }
</style>
